const Style = {
  modal: {
    marginTop: '4em',
  },
  modalBody: {
    position: 'relative' as const,
    flex: '1 1 auto',
    padding: '1rem',
  },
  buttonIconGroup: {
    margin: '20px 0px',
    display: 'flex',
  },
  buttonIcon: {
    width: '100px',
    height: '100px',
    padding: '12px 0px',
    textAlign: 'center' as const,
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center' as 'center',
    justifyContent: 'space-between' as 'space-between',
    border: 'solid 1px transparent',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  buttonIconSelected: {
    backgroundColor: '#e8e8e8',
    width: '100px',
    height: '100px',
    padding: '12px 0px',
    textAlign: 'center' as const,
    display: 'flex',
    flexDirection: 'column' as 'column',
    alignItems: 'center' as 'center',
    justifyContent: 'space-between' as 'space-between',
    border: 'solid 1px #b9b9b9',
    borderRadius: '4px',
    cursor: 'pointer',
  },
  label: {
    fontSize: '12px',
  },
  textarea: {
    width: '98%',
  },
};

export default Style;
